export default {
    getFilter,
    getUriComponent,
    fromHNode,
    pageResetRequired: true
};

function fromHNode() {
    return getFilter();
}

function getFilter() {
    return {};
}

// TODO: implement on server side for online clients.
// Default for offline sync - no application for online.
function getUriComponent() {
    return 'includeDeleted=true';
}
